import { useMediaQuery } from 'react-responsive';
import { breakPoints } from 'app/constants';
import { Row } from 'antd';
import {
    ProductCardLink,
    ProductCardLoader,
} from 'app/modules/shop/components/productCard';
import { map } from 'underscore';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useGetLandingProductsQuery } from 'app/api';
import { Pagination } from 'app/shared/pagination/pagination';

export const LendingProducts = memo(
    ({
        uuid,
        point,
        isAdmin,
        data: products,
        setInitialData,
        setAllData,
        getProducts,
        allProducts,
        isAdded,
    }) => {
        const [page, setPage] = useState(0);
        const isMobile = !useMediaQuery({
            query: breakPoints.xsMobile,
        });
        const onProductClick = useCallback((e) => {
            e.preventDefault();
        }, []);
        const { data, isFetching } = useGetLandingProductsQuery(
            {
                id: uuid,
                point,
                page,
            },
            { skip: !isAdded }
        );

        function onPaginationChange(page) {
            setPage(page);
        }

        const response = data?.data_response;
        useEffect(() => {
            if (data?.success) {
                setInitialData(uuid, response?.data);
            }
        }, [data, page]);

        useEffect(() => {
            if (isAdmin && isAdded && uuid && !allProducts) {
                getProducts(uuid, (response) => {
                    if (response.success) {
                        setAllData(uuid, response?.data);
                    }
                });
            }
        }, [isAdmin]);
        if (response?.success === false || response?.count === 0) return null;
        return (
            <div className={'lending-categories'}>
                <Row
                    gutter={isMobile ? [15, 15] : [30, 30]}
                    style={{
                        width: '100%',
                        marginLeft: 0,
                        marginRight: 0,
                        gap: '15px',
                    }}
                >
                    {isFetching
                        ? Array.from({ length: 8 }).map((_, index) => {
                              return (
                                  <div
                                      style={{ minWidth: '200px', flex: 1 }}
                                      key={index}
                                  >
                                      <ProductCardLoader
                                          height={isMobile ? 270 : 320}
                                      />
                                  </div>
                              );
                          })
                        : map(products, (item) => {
                              return (
                                  <div
                                      style={{ minWidth: '200px', flex: 1 }}
                                      key={item.id}
                                  >
                                      <ProductCardLink
                                          rowView={isMobile}
                                          product={item}
                                          className={'lending-product'}
                                          onClick={onProductClick}
                                      />
                                  </div>
                              );
                          })}
                </Row>
                {response?.success && response.page_max > 1 ? (
                    <Pagination
                        disabled={isFetching}
                        pageSize={response.row}
                        total={response.count}
                        current={response.page}
                        onChange={onPaginationChange}
                        className={'mt-3'}
                        style={{ margin: '0 auto' }}
                    />
                ) : null}
            </div>
        );
    }
);
